module.exports = __webpack_public_path__ + "static/media/Diversity.1edb9797.jpg";